import { useTranslation } from "react-i18next";
import { useChannelStats } from "@/lib/inviter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const VERDICT_TONE: Record<string, string> = {
  good: "text-success",
  neutral: "text-fg-muted",
  toxic: "text-danger",
  insufficient_data: "text-fg-muted",
};

/**
 * Source-channel invite quality (C4). Shows which channels the audience was
 * scraped from convert well vs are toxic (high PeerFlood / low add rate), so
 * the operator can blacklist the bad ones. Read-only; hidden until there's
 * enough data (insufficient_data rows are filtered out).
 */
export function ChannelQualityCard() {
  const { t } = useTranslation();
  const stats = useChannelStats();
  const rows = (stats.data ?? []).filter((r) => r.verdict !== "insufficient_data");
  if (!stats.data || rows.length === 0) return null;
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{t("inviter.channel_quality.title")}</CardTitle>
        <p className="text-sm text-fg-muted">{t("inviter.channel_quality.subtitle")}</p>
      </CardHeader>
      <CardContent className="divide-y divide-border">
        {rows.map((r) => (
          <div
            key={r.channel_id}
            className="flex items-center justify-between gap-3 py-2 text-sm"
          >
            <span className="min-w-0 truncate font-mono text-xs">
              {r.username ? `@${r.username}` : (r.title ?? r.channel_id.slice(0, 8))}
            </span>
            <span className="flex shrink-0 items-center gap-3 text-xs">
              <span className="text-fg-muted">
                {t("inviter.channel_quality.added_of", { added: r.added, reached: r.reached })}
              </span>
              <span className={VERDICT_TONE[r.verdict] ?? "text-fg-muted"}>
                {t(`inviter.channel_quality.verdict_${r.verdict}`)}
              </span>
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
